import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceHours = () => {
  const serviceHours = [
    {
      day: 'จันทร์ - ศุกร์',
      hours: '08:30 - 16:30 น.',
      type: 'regular'
    },
    {
      day: 'เสาร์ - อาทิตย์',
      hours: 'ปิดทำการ',
      type: 'closed'
    },
    {
      day: 'วันหยุดนักขัตฤกษ์',
      hours: 'ปิดทำการ',
      type: 'closed'
    }
  ];

  const contactInfo = [
    {
      type: 'phone',
      label: 'โทรศัพท์',
      value: '053-795-345',
      icon: 'Phone'
    },
    {
      type: 'fax',
      label: 'โทรสาร',
      value: '053-795-883',
      icon: 'Printer'
    },
    {
      type: 'email',
      label: 'อีเมล',
      value: 'districtthoeng@gmail.com',
      icon: 'Mail'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-government">
      <div className="mb-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Clock" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">
            เวลาทำการ
          </h3>
        </div>
        
        <div className="space-y-3">
          {serviceHours?.map((schedule, index) => (
            <div key={index} className="flex justify-between items-center py-2">
              <span className="text-foreground font-medium">
                {schedule?.day}
              </span>
              <span className={`text-sm font-medium ${
                schedule?.type === 'closed' ?'text-muted-foreground' :'text-success'
              }`}>
                {schedule?.hours}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-border pt-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Phone" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">
            ติดต่อสอบถาม
          </h3>
        </div>
        
        <div className="space-y-3">
          {contactInfo?.map((contact, index) => (
            <div key={index} className="flex items-center space-x-3">
              <Icon name={contact?.icon} size={16} className="text-muted-foreground" />
              <div className="flex-1">
                <span className="text-sm text-muted-foreground">
                  {contact?.label}:
                </span>
                <span className="ml-2 text-foreground font-medium">
                  {contact?.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-border pt-6 mt-6">
        <div className="flex items-center space-x-2 mb-3">
          <Icon name="MapPin" size={20} className="text-primary" />
          <h4 className="font-semibold text-foreground">ที่อยู่</h4>
        </div>
        <p className="text-sm text-muted-foreground leading-relaxed">
          สำนักงานอำเภอเทิง ถนนพิศาล ตำบลเทิง อำเภอเทิง จังหวัดเชียงราย 57160
        </p>
      </div>
    </div>
  );
};

export default ServiceHours;